/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyertaglinequeue3Inputs */

const en_checkinflyertaglinequeue3 = /** @type {(inputs: Checkinflyertaglinequeue3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peek at who's inside – and say hi before you get in.`)
};

const de_checkinflyertaglinequeue3 = /** @type {(inputs: Checkinflyertaglinequeue3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schau schon mal, wer drin ist – und sag Hi, bevor du reinkommst.`)
};

/**
* | output |
* | --- |
* | "Peek at who's inside – and say hi before you get in." |
*
* @param {Checkinflyertaglinequeue3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyertaglinequeue3 = /** @type {((inputs?: Checkinflyertaglinequeue3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyertaglinequeue3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyertaglinequeue3(inputs)
	return de_checkinflyertaglinequeue3(inputs)
});
export { checkinflyertaglinequeue3 as "checkinFlyerTaglineQueue" }